export var VisionPolicePresenceRequestedActionType;
(function (VisionPolicePresenceRequestedActionType) {
    VisionPolicePresenceRequestedActionType["requestPolicePresence"] = "requestPolicePresence";
    VisionPolicePresenceRequestedActionType["notRequestPolicePresence"] = "notRequestPolicePresence";
})(VisionPolicePresenceRequestedActionType || (VisionPolicePresenceRequestedActionType = {}));
//# sourceMappingURL=vision.js.map